import { useState, useEffect } from 'react';

const MOBILE_MAX = 767;
const TABLET_MAX = 1024;

function classify(width) {
  if (width <= MOBILE_MAX) return 'mobile';
  if (width <= TABLET_MAX) return 'tablet';
  return 'desktop';
}

// Reactive breakpoint: mobile <768px, tablet 768-1024px, desktop >1024px.
export function useBreakpoint() {
  const [mode, setMode] = useState(() => classify(window.innerWidth));

  useEffect(() => {
    function onResize() {
      setMode(prev => {
        const next = classify(window.innerWidth);
        return next === prev ? prev : next;
      });
    }
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return {
    mode,
    isMobile: mode === 'mobile',
    isTablet: mode === 'tablet',
    isDesktop: mode === 'desktop',
  };
}
